import { PaginationRequestModel } from "../../../models";

export class SearchTasksModel {
  /**Id проекта */
  ProjectId?: number;
  /**Id родительской задачи */
  MainTaskId?: number;
  /**Строка поиска */
  SearchValue!: string;
  /**id НС */
  NamespaceId?: string;
  /**Запрос пагинации */
  Page!: PaginationRequestModel;
  /**ID очереди задач */
  QueueTaskId!: string;
  /**Исключить подзадачи */
  WithoutChildTask: boolean = true;
  /**Исключить родителя */
  WithoutParentTask: boolean = true;
  /**Идентификаторы  */
  IgnoreTaskList!: Array<number>;

  constructor(obj?: Partial<SearchTasksModel>) {
    Object.assign(this, obj);
  }
}
